import { PlaceholdersId, TFComponent } from '@types';
import { TitleResumeAndAuthorizationPlaceholder } from './titleResumeAndAuthorization';

export const titleResumeAndAuthorization: TFComponent = {
	component: TitleResumeAndAuthorizationPlaceholder,
	id: PlaceholdersId.titleResumeAndAuthorization,
	name: 'titleResumeAndAuthorization',
};
